import { SidebarSection } from './SidebarSection';
import styles from './TagFilters.module.css';

interface TagFiltersProps {
  counts: Record<string, number>;
  selectedTag: string | null;
  onSelect: (tag: string | null) => void;
}

/** Sidebar Tags section — the server's top-N tags by live-bookmark count.
 *  Hidden while no bookmark carries a tag. */
export function TagFilters({ counts, selectedTag, onSelect }: TagFiltersProps) {
  const tags = Object.keys(counts).sort((a, b) => counts[b] - counts[a] || a.localeCompare(b));
  if (tags.length === 0) return null;

  return (
    <SidebarSection id="tags" title="Tags" activeLabel={selectedTag}>
      <div className={styles.chips}>
      {tags.map((tag) => (
        <button
          key={tag}
          className={`${styles.chip} ${selectedTag === tag ? styles.selected : ''}`}
          aria-pressed={selectedTag === tag}
          title={tag}
          onClick={() => onSelect(selectedTag === tag ? null : tag)}
        >
          <span className={styles.label}>{tag}</span>
          <span className={styles.count}>{counts[tag]}</span>
        </button>
      ))}
      </div>
    </SidebarSection>
  );
}
